// extracted by mini-css-extract-plugin
module.exports = {"ManualTopList":"Single_ManualTopList__yObbM","Header":"Single_Header__smU5S"};